module.exports = __webpack_public_path__ + "static/media/expand_business.b632f7c5.svg";